import React, {Component} from 'react';
import $ from 'jquery';


import Router from "./Router";
import Header from "./Header";
import Footer from "./Footer";
import Livebackground from "./Livebackground";




class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seconds: parseInt(props.startTimeInSeconds, 500) || 0,
      bg: "https://www.glerl.noaa.gov/metdata/mkg/mkg01.jpg#",
      timeClass: '',
      isLoaded: ''
    };
  }

  gettime() {
    return (
      new Date().getHours()
    )
  }

  isitNite() {
    let hour = this.gettime();
    if (hour >= 16 || hour < 8) {
      this.setState(state => ({
        timeClass: 'night'
      }));
    } else {
      this.setState(state => ({
        timeClass: 'day'
      }));
    }
  }

  tick() {
    this.isitNite();
    $('<div class="backgroundImage ' + this.state.seconds + '" style="background-image: url(' + this.state.bg + ')"></div>').hide().prependTo('.site').fadeIn(600);
    $('.site > .backgroundImage:gt(1)').delay(5000).remove()
    this.setState(state => ({
      seconds: state.seconds + 1,
      bg: state.bg + state.seconds
    }));
  }

  componentDidMount() {
    this.setState(state => ({
      isLoaded: 'loaded'
    }));
    this.isitNite();
    $('<div class="backgroundImage" style="background-image: url(' + this.state.bg + ')"></div>').hide().prependTo('.site').fadeIn(200);
    $('.site > .backgroundImage:gt(1)').delay(5000).remove()

    this.interval = setInterval(() => this.tick(), 60000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <div className={`site ${ this.state.timeClass } ${ this.state.isLoaded }`}>
        <div className="site-content">
          <Header/>
          <Router/>
          <Footer/>
        </div>
      </div>
    );
  }
}

export default Layout